import React from 'react';
import styles from './PercentageBar.module.scss';
import Tooltip from '../../miscellaneous/Tooltip/Tooltip';
import { FiInfo } from 'react-icons/fi';
import _ from 'lodash';


class PercentageBar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            values: {
                total: 100,
                full: 0,
                type: 'percent',    // 'numeric'
                valueText: '100%',
                bottomText: 'name',
                infoText: 'explanation'
            },
            colors: {
                colorFull: '#5f1515',
                colorEmpty: '#ffc5c5',
            },
            styles: {
                height: '180px',
                width: '45px',
                border: '1px solid #5f1515',
                borderRadius: '30px'
            }
        };
    }

    componentDidMount() {
        this.init();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(!_.isEqual(prevProps, this.props)) {
            this.init()
        }
    }

    init() {
        let state = { ...this.state };

        if (this.props.values) {
            _.forEach(this.props.values, (v, k) => {
                state.values[k] = v;
            });
        }

        if (this.props.colors) {
            _.forEach(this.props.colors, (v, k) => {
                state.colors[k] = v;
            });
        }

        if (this.props.styles) {
            _.forEach(this.props.styles, (v, k) => {
                state.styles[k] = v;
            });
        }

        state.values.text = this.state.values.type === 'percent' ? (this.state.values.full / this.state.values.total * 100).toFixed(1) + '%' : this.state.values.full + '/' + this.state.values.total;
        this.setState(state);
    }

    refillBar() {
        let values = {...this.state.values}
        values.full = 0;
        this.setState({values: values}, () => {
            values.full = this.props.values.full;
            setTimeout(
                () => this.setState({values: values}),
                600
            );
        })
    }

    render() {
        return (
            <div className={`${styles['padding-container']}`}>

                <div className={`${styles['container']}`} style={{ width: this.state.styles.width }}>
                    <div className={`${styles['value']}`}>
                        {this.state.values.text}
                    </div>
                    <div className={`${styles['info']}`}>
                        <Tooltip content={this.state.values.infoText}>
                            <FiInfo className={`${styles['info-icon']}`}/>
                        </Tooltip>
                    </div>

                    <div className={`${styles['bar-outer-container']}`} style={{
                        height: this.state.styles.height,
                        borderRadius: this.state.styles.borderRadius,
                        border: '1px solid ' + this.state.colors.colorFull,
                        background: this.state.colors.colorEmpty,
                    }}
                    onClick={() => this.refillBar()}>
                        <div className={`${styles['bar-container']}`} style={{
                            border: '1px solid ' + this.state.colors.colorEmpty,
                            borderRadius: this.state.styles.borderRadius,
                        }}>
                            <div className={`${styles['empty']}`} style={{}}>

                            </div>
                            <div className={`${styles['full']}`} style={{
                                height: this.state.values.full + '%',
                                background: this.state.colors.colorFull
                            }}>

                            </div>
                        </div>
                    </div>

                </div>
                <div className={`${styles['bottom-text']}`}>{this.state.values.bottomText}</div>
            </div>
        );
    }
}

export default PercentageBar;
